import { Button } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';

import TableRender, { RenderBoolean, TableRenderFieldT } from 'shared/components/Table/TableRender';
import { OrganizationT } from 'shared/models/organizations';
import api from 'utils/api';

function Organizations() {
  const history = useHistory();

  const fields: TableRenderFieldT[] = [
    {
      displayName: 'Name',
      renderFn: (row: OrganizationT) => row.displayName,
      align: 'center',
    },
    {
      displayName: 'Devices Limit',
      renderFn: (row: OrganizationT) => row.deviceLimit,
      align: 'center',
    },
    {
      displayName: 'IP Networks Limit',
      renderFn: (row: OrganizationT) => (row.poolLimit === '0' ? 'Unlimited' : row.poolLimit),
      align: 'center',
    },
    {
      displayName: 'Sources Limit',
      renderFn: (row: OrganizationT) => (row.sourceLimit === '0' ? 'Unlimited' : row.sourceLimit),
      align: 'center',
    },
    {
      displayName: 'Encryption',
      renderFn: (row: OrganizationT) => RenderBoolean(row.enableEncryption, 'icon'),
      align: 'center',
    },
    {
      displayName: 'Active',
      renderFn: (row: OrganizationT) => RenderBoolean(row.active, 'icon'),
      align: 'center',
    },
  ];

  const goToSourceID = (organizationName: string) => {
    history.push(`/organizations/${organizationName}`);
  };

  return (
    <div>
      <div className="title__header">
        <h1>Organizations</h1>
        <Link to="/organizations/create">
          <Button variant="contained" color="secondary">Create</Button>
        </Link>
      </div>
      <TableRender
        api={api.organizations}
        renderFields={fields}
        onClickRow={(row: OrganizationT) => goToSourceID(row.name)}
        hasNoPagination
      />
    </div>
  );
}

export default Organizations;
